import { render, staticRenderFns } from "./SimpleLoader.html?vue&type=template&id=f506f4fc&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleLoader.scss?vue&type=style&index=0&id=f506f4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f506f4fc",
  null
  
)

export default component.exports